import { RootState } from '@/store/index';
import { useSelector } from 'react-redux';
import { maxScreenWidthForDesktop } from "@/pages/watch/main/constants"

import DesktopCommentsView from "./view"
import { useEffect, useRef, useState } from 'react';
import { commentStatus } from "@/components/video/videoComments/main/constants";

export default function DesktopComments(props: any) {
    const allComments = useSelector((state: RootState) => state.commentsReducer.comments);
    const profileDetails = useSelector((state: RootState) => state.profileReducer.profile);
    const screenWidth = useSelector((state: RootState) => state.screenWidthReducer.screenWidth);
    const zeroCommentConRef = useRef<HTMLDivElement | null>(null);
    const [showCommentBox1WhenAddCommentBtnIsClick, setShowCommentBox1WhenAddCommentBtnIsClick] = useState(true)
    // testing
    // useEffect(() => {
    //     console.log("allComments : ", allComments)
    // }, [allComments])


    useEffect(() => {
        const frame = requestAnimationFrame(() => {
            updateHeightOfZeroCommentConRef();
        });

        window.addEventListener('resize', updateHeightOfZeroCommentConRef);

        return () => {
            cancelAnimationFrame(frame);
            window.removeEventListener('resize', updateHeightOfZeroCommentConRef);
        };
    }, []);


    useEffect(() => {
        if (window.innerWidth < maxScreenWidthForDesktop) {
            setShowCommentBox1WhenAddCommentBtnIsClick(false)
        }
    }, [])


    const updateHeightOfZeroCommentConRef = () => {
        if (zeroCommentConRef.current) {
            const rect = zeroCommentConRef.current.getBoundingClientRect();
            const top = rect.top;
            const availableHeight = window.innerHeight - top - 92;
            // const availableHeight = window.innerHeight - top;
            zeroCommentConRef.current.style.height = `${availableHeight}px`;
        }
    };

    const handleAddCommentBtn = () => {
        if (window.innerWidth < maxScreenWidthForDesktop) {
            setShowCommentBox1WhenAddCommentBtnIsClick(true)
        }
    }

    const handleBlur = () => {
        if (window.innerWidth < maxScreenWidthForDesktop) {
            setShowCommentBox1WhenAddCommentBtnIsClick(false)
            requestAnimationFrame(() => {
                updateHeightOfZeroCommentConRef();
            });
        }
    }

    const showComment = (comment: any) => {
        // console.log(comment, profileDetails)
        if (comment.status === commentStatus.published) {
            return true
        } else if (profileDetails._id && comment.userId
            && profileDetails._id === comment.userId) {
            return true
        }
        return false
    }

    return (
        <>
            <DesktopCommentsView
                allComments={allComments}
                profileDetails={profileDetails}
                screenWidth={screenWidth}
                zeroCommentConRef={zeroCommentConRef}
                handleAddCommentBtn={handleAddCommentBtn}
                showCommentBox1WhenAddCommentBtnIsClick={showCommentBox1WhenAddCommentBtnIsClick}
                handleBlur={handleBlur}
                showComment={showComment}
            />
        </>
    );
}


